import { SxProps, Theme } from '@rossum/ui/material';

export const pageSpacingStyles: SxProps<Theme> = {
  py: 2,
  width: 0.75,
  mx: 'auto',
};
